import {LineListRequest} from '../../entity/model/line-list-request';
import LineListRequestStore from '../store/line-list-request-store';
import {LineListReportProps} from '../../entity/props/title/line-list-report-props';
import {State} from '../../entity/model/state';
import {County} from '../../entity/model/county';
import {pdf} from '@react-pdf/renderer';
import React from 'react';
import LineListReportDocument from '../../app/layout/components/report/LineListReportDocument';
import { toast } from 'react-toastify';

export default class LineListRequestService {
    constructor(private lineListRequestStore: LineListRequestStore) {}

    getLineListRequestDto = (): LineListRequest => {
        const props = this.lineListRequestStore.currentProps;

        return {
            _id: props?.reportData?._id ?? crypto.randomUUID(),
            comment: props?.reportData?.comment ?? '',
            orderInformation: {
                orderNumber: props?.reportData?.orderInformation?.orderNumber ?? props?.project?.orderNumber ?? '',
                searchType: props?.reportData?.orderInformation?.searchType ?? props?.project?.searchType ?? '',
                searchStartDate: props?.reportData?.orderInformation?.searchStartDate ?? '',
                searchEndDate: props?.reportData?.orderInformation?.searchEndDate ?? ''
            },
            propertyInformation: {
                stateID: props?.reportData?.propertyInformation?.stateID ?? props?.title?.stateID ?? props?.project?.stateID ?? '',
                countyID: props?.reportData?.propertyInformation?.countyID ?? props?.title?.countyID ?? props?.project?.countyID ?? '',
                propertyAddress: props?.reportData?.propertyInformation?.propertyAddress ?? props?.title?.address ?? props?.project?.address ?? '',
                parcelNumber: props?.reportData?.propertyInformation?.parcelNumber ?? props?.title?.tmsParcelNumbers?.[0] ?? ''
            },
            ownerInformation: props?.reportData?.ownerInformation ?? [],
            occupantInformation: props?.reportData?.occupantInformation ?? [],
            acquisitionDetails: {
                tractSize: props?.reportData?.acquisitionDetails?.tractSize ?? '',
                easementSize: props?.reportData?.acquisitionDetails?.easementSize ?? ''
            },
            vestingDeed: props?.reportData?.vestingDeed ?? [],
            estates: props?.reportData?.estates ?? [],
            taxYears: props?.reportData?.taxYears ?? [],
            taxFlags: {
                pendingTaxSale: props?.reportData?.taxFlags?.pendingTaxSale ?? false,
                delinquentTaxes: props?.reportData?.taxFlags?.delinquentTaxes ?? false,
                rollBackTaxes: props?.reportData?.taxFlags?.rollBackTaxes ?? false,
                taxExempt: props?.reportData?.taxFlags?.taxExempt ?? false
            },
            mobileHome: props?.reportData?.mobileHome ?? [],
            restrictionsAgreements: props?.reportData?.restrictionsAgreements ?? [],
            easementsRightOfWays: props?.reportData?.easementsRightOfWays ?? []
        };
    }

    loadSharedData = (): void => {
        this.lineListRequestStore.loadSharedData();
    }

    getCurrentStateId = (): string => {
        const props = this.lineListRequestStore.currentProps;
        return props?.title?.stateID ?? props?.project?.stateID ?? '';
    }

    getCurrentProps = (): LineListReportProps | undefined => {
        return this.lineListRequestStore.currentProps;
    }

    setCurrentProps = (props: LineListReportProps | undefined): void => {
        this.lineListRequestStore.setCurrentProps(props);
    }

    generateLineListReportPdf = async (lineListRequest: LineListRequest, state?: State, county?: County): Promise<Blob> => {
        try {
            return await pdf(
                React.createElement(LineListReportDocument, {
                    lineListRequest: lineListRequest,
                    state: state,
                    county: county
                }) as React.ReactElement
            ).toBlob();
        } catch (error) {
            console.error('Error generating PDF report:', error);
            throw error;
        }
    }

    createLineListRequest = async (organizationId: string, lineListRequest: LineListRequest): Promise<void> => {
        const result = await this.lineListRequestStore.createLineListRequest(organizationId, { body: lineListRequest });
        if (typeof result === 'string')
            toast.error(result);
        else
            toast.success('Line list request created successfully!');
    }

    loadLineListRequests = async (organizationId: string, titleId: string): Promise<LineListRequest[]> => {
        const result = await this.lineListRequestStore.loadLineListRequests(organizationId, titleId);
        if (typeof result === 'string') {
            toast.error(result);
            return [];
        }
        return result;
    }

    getLineListRequest = (documentId: string): LineListRequest | undefined => {
        return this.lineListRequestStore.lineListRequests.find((lineListRequest: LineListRequest) => lineListRequest.documentID === documentId);
    }

    updateLineListRequest = async (organizationId: string, lineListRequestId: string, lineListRequest: LineListRequest): Promise<void> => {
        const result = await this.lineListRequestStore.updateLineListRequest(organizationId, lineListRequestId, { body: lineListRequest });
        if (typeof result === 'string')
            toast.error(result);
        else
            toast.success('Line list request updated successfully!');
    }
}
